package com.essntl.features.service.data.supabase.service

import com.essntl.core.supabase.SupabaseDataSource
import io.github.jan.supabase.SupabaseClient
import org.koin.core.annotation.Single

@Single(binds = [ServiceSupabaseDataSource::class])
internal class ServiceSupabaseDataSource(
    override val supabaseClient: SupabaseClient,
) : SupabaseDataSource<ServiceDto> {
    override val tableName: String = "service"
}
